import React, { ReactNode } from 'react';
import { ChevronDownIcon, EllipsisIcon, MegaphoneIcon } from 'lucide-react';
import { pencilAds } from '../../../data/pencilCanvas';

/** The "Works" card: one creative, four formats, with an AI score. */
export function PencilAssetCard({
  x,
  y
}: {
  x: number;
  y: number;
}) {
  return <div className="absolute w-[466px] rounded-xl border border-[#E0E0E0] bg-white p-2 shadow-[0_4px_8px_rgba(18,19,20,0.04)]" style={{
    left: x,
    top: y
  }} data-id="element-168" data-mp="1xggmld3n7f7b">
      <div className="flex h-8 items-center gap-6" data-id="element-169" data-mp="2be4w5os9ezx2">
        <div className="flex min-w-0 flex-1 items-center gap-1" data-id="element-170" data-mp="26gd6z2j01rwk">
          <span className="grid h-6 w-6 place-items-center" data-id="element-171" data-mp="2l617w2n9qojr">
            <MegaphoneIcon size={17} className="text-[#8347FF]" strokeWidth={2.2} data-id="element-172" data-mp="2l5j0qaz2ipx2" />
          </span>
          <div className="flex items-center gap-2 text-[14px] font-medium leading-5" data-id="element-173" data-mp="2g7zn9da72h66">
            <span className="text-[#191915]" data-id="element-174" data-mp="2u7ijb7pqe224">Speed goat</span>
            <span className="h-[3px] w-[3px] rounded-full bg-ink" data-id="element-175" data-mp="2q5x9xwceo5wo" />
            <span className="text-[#707070]" data-id="element-176" data-mp="2q3klr1g20zb6">4 formats</span>
          </div>
        </div>
        <div className="flex items-center gap-2.5" data-id="element-177" data-mp="1ebc9ii66ax8n">
          <span className="flex h-8 items-center gap-0.5 rounded bg-[#26A871] pl-1.5 pr-0.5 text-[18px] font-semibold leading-[22px] text-white" data-id="element-178" data-mp="1ia2yu34edal7">
            65
            <ChevronDownIcon size={18} data-id="element-179" data-mp="1s90s1jcrpsaj" />
          </span>
          <span className="flex h-8 items-center rounded border border-[#E0E0E0] px-3 text-[14px] font-medium text-ink" data-id="element-180" data-mp="1salnrcatjh9z">Edit</span>
          <span className="grid h-8 w-8 place-items-center text-[#191915]" data-id="element-181" data-mp="1x6aq1ne83c9z">
            <EllipsisIcon size={20} data-id="element-182" data-mp="217vz0xnmz6ew" />
          </span>
        </div>
      </div>
      <div className="relative mt-2 h-[253px] overflow-hidden rounded" data-id="element-183" data-mp="261grka6gn86p">
        <img src={pencilAds.wide} alt="" className="h-full w-full object-cover" data-id="element-184" data-mp="2b01pu425jhsi" />
        <div className="absolute inset-x-0 bottom-5 text-center text-white [text-shadow:0_2px_14px_rgba(18,19,20,0.45)]" data-id="element-185" data-mp="2fylfaefyfbpm">
          <p className="font-display text-[54px] font-extrabold italic leading-none tracking-[-0.03em]" data-id="element-186" data-mp="2kwwmsiis1a4o">SPEEDGOAT 6</p>
          <p className="mt-1 text-[15px] font-bold tracking-[0.45em]" data-id="element-187" data-mp="1vac27bqv7epa">HOKA</p>
        </div>
      </div>
      <div className="mt-2 flex gap-2" data-id="element-188" data-mp="1qbsdj3kvzot8">
        <Thumb active data-id="element-189" data-mp="1q8mpzsrwouzm">
          <img src={pencilAds.wide} alt="" className="h-[31px] w-[54px] object-cover" data-id="element-190" data-mp="24zvlujmejcl7" />
        </Thumb>
        <Thumb data-id="element-191" data-mp="2083rdy04kmps">
          <img src={pencilAds.story} alt="" className="h-[54px] w-[30px] object-cover" data-id="element-192" data-mp="207lzfdkhwuno" />
        </Thumb>
        <Thumb data-id="element-193" data-mp="2dz0ljt9p9byy">
          <img src={pencilAds.square} alt="" className="h-14 w-14 object-cover" data-id="element-194" data-mp="2dyh1o70hodia" />
        </Thumb>
        <Thumb data-id="element-195" data-mp="290fhtjv8oa5r">
          <img src={pencilAds.landscape} alt="" className="h-[40px] w-[54px] object-cover" data-id="element-196" data-mp="2931pdji4qpnz" />
        </Thumb>
      </div>
    </div>;
}
function Thumb({
  children,
  active = false
}: {
  children: ReactNode;
  active?: boolean;
}) {
  return <span className={`grid h-14 w-14 place-items-center overflow-hidden rounded bg-[#EBEBEB] ${active ? 'border border-ink' : ''}`} data-id="element-197" data-mp="tjxag93r4egt">
      {children}
    </span>;
}